module.exports = __webpack_public_path__ + "img/weiyuanhui.f5f2c609.png";